module.exports = __webpack_public_path__ + "carousel_04_img_01.png?f8f2c3608871a1e29b27e36ccfff93fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_01.png
// module id = 156
// module chunks = 0